import { ActiveRentalStatusCard } from "../components/user_rentals/ActiveRentalStatusCard"
import { DateRangePickerComponent } from "../components/form/DateRangePickerComponent";
import { DateRange } from "react-day-picker";
import { useEffect, useState } from "react";
import { Label } from "../components/form/Label";
import Dropdown from "../components/form/Dropdown";
import { SearchBar } from "../components/navbar/SearchBar";
import { Input } from "../components/form/Input";
import { ActiveRentalStatusCardSkeleton } from "../components/skeletons/ActiveRentalStatusCardSkeleton";
import CarRentalIcon from '@mui/icons-material/CarRental';
import { NoneUserRented } from "./NoneUserRentedPage";
import { UserRentalDetail } from "../api/requests/interfaces/Rental";
import { getUserRentals } from "../api/requests/rental";
import { RentalStatus } from "../api/requests/interfaces/Channel";
import { productStatusOptions } from "../constants/products";
import { Helmet } from "react-helmet-async";
import {Pagination} from "@mui/material";

export const UserRentalsList = () => {

    const [filterSearch, setFilterSearch] = useState(String);
    const [filterDate, setFilterDate] = useState<DateRange | undefined>();
    const [filterStatus, setFilterStatus] = useState<RentalStatus | undefined>(undefined);

    const [totalRentalsCount, setTotalRentalsCount] = useState(0);
    const [rentalsPage, setRentalsPage] = useState(0);
    const [rentalsTakeCount, setRentalsTakeCount] = useState(10);

    const [rentalsList, setRentalsList] = useState<UserRentalDetail[]>([]);

    const [dataLoading, setDataLoading] = useState(true)

    const [initialRentalsLoad, setInitialRentalsLoad] = useState<UserRentalDetail[]>([]);


    /* const dummyData = [
        {
            id: 1,
            amount: 90, // Total rental cost
            state: RentalStatus.IN_RENT,
            startDate: new Date("2025-01-10T09:00:00"),
            endDate: new Date("2025-01-15T18:00:00"),
            chatChannelId: 12345,
            product: {
                id: 101,
                title: "Makita Electric Drill",
                imageUrl: "https://via.placeholder.com/150",
                location: "Tallinn, Estonia",
                dayPrice: 15,
            },
            person: {
                id: 1,
                name: "John Doe",
                profilePicUrl: "https://via.placeholder.com/50",
            },
        },
        {
            id: 1,
            amount: 90, // Total rental cost
            state: RentalStatus.RENT_FINISHED,
            startDate: new Date("2025-01-10T09:00:00"),
            endDate: new Date("2025-01-15T18:00:00"),
            chatChannelId: 12345,
            product: {
                id: 101,
                title: "Makita Electric Drill",
                imageUrl: "https://via.placeholder.com/150",
                location: "Tallinn, Estonia",
                dayPrice: 15,
            },
            person: {
                id: 1,
                name: "John Doe",
                profilePicUrl: "https://via.placeholder.com/50",
            },
        },


    ]; */


    useEffect(() => {
        fetchUserRentals();
    }, [])

    useEffect(() => {
        fetchUserRentals();
    }, [filterDate, filterStatus, rentalsPage, rentalsTakeCount])

    const fetchUserRentals = async () => {
        setDataLoading(true);
        setRentalsList([]); // Without this line for some odd reason a random rental will stay in the list
        const data = await getUserRentals(true,
            rentalsPage*rentalsTakeCount, rentalsTakeCount, filterDate?.from, filterDate?.to, filterStatus);
        setRentalsList(data.data);
        setTotalRentalsCount(data.total);
        if (!initialRentalsLoad.length) {
            setInitialRentalsLoad(data.data);
        }
        setDataLoading(false);
    }

    /* const rentalItems: any[] = [{
        title: "Makita trell",
        status: RentalStatus.IN_PROGRESS,
        description: "Heatrell suureparane ja hea kasutada",
        price: "12",
        date_listed: new Date("2024-12-10")
    }, {
        title: "Makita trell",
        status: RentalStatus.REQUESTED,
        description: "Heatrell suureparane ja hea kasutada",
        price: "12",
        date_listed: new Date("2024-12-22")
    }, {
        title: "Makita trell",
        status: RentalStatus.REQUESTED,
        description: "Heatrell suureparane ja hea kasutada",
        price: "12",
        date_listed: new Date("2024-12-15")
    },
    {
        title: "Makita trell",
        status: RentalStatus.FINISHED,
        description: "Heatrell suureparane ja hea kasutada",
        price: "12",
        date_listed: new Date("2024-12-15")
    }] */

    // Key to exclude
    /* const excludeKey: keyof typeof RentalStatus = "AD_CREATED";
    const rentalStatusStrings: string[] = Object.values(RentalStatus).filter(
        (status) => status !== RentalStatus[excludeKey]
    );

    const isFilterDateEmpty = (filterDate: { from?: Date; to?: Date } | undefined): boolean => {
        return !filterDate || (!filterDate.from && !filterDate.to);
    };

    const isDateInRange = (date: Date, range: DateRange | null): boolean => {
        if (!range || !range.from || !range.to) {
            return false; // If range is null or incomplete, return false
        }

        return date >= range.from && date <= range.to; // TODO: Date range filter <= operator isnt still displaying the last day, as if there was < not <=
    }; */

    // Checking if item properties fall inside all filters
    /* const shouldDisplay = (item: {
        title: string,
        status: string;
        date_listed: Date;
    }): boolean => {

        if (isFilterDateEmpty(filterDate) && !filterStatuses.length && !filterSearch) {return true} // If all filter fields are empty

        const isSearchValid = item.title.toLowerCase().includes(filterSearch.toLowerCase()) || !filterSearch; // These constants also set to true if current filter is empty
        const isStatusValid = filterStatuses.includes(item.status) || !filterStatuses.length; 
        const isDateValid = filterDate ? isDateInRange(item.date_listed, filterDate) || !filterDate.to : false;

        console.log(filterSearch);
        console.log(filterStatuses.length);
        console.log(filterDate);

        return isStatusValid && isDateValid && isSearchValid;
    }; */

    if (!initialRentalsLoad.length && !dataLoading) {
        return (
            <NoneUserRented text={"Sa pole veel ühtegi kuulutust teinud."} buttonLink="/edit" buttonText="Loo kuulutus" icon={<CarRentalIcon className="text-primary" style={{ height: "100px", width: "100px" }} />} />
        )
    }

    return (

        (<div className="pt-[30px]">

            <Helmet>
                <title>Rentic - Minu Renti Pandud</title>
                <meta name="description" content="Minu aktiivsed rendid Renticus. Vaata üksikasju enda hetkel välja renditud esemete kohta." />
                <meta name="keywords" content="rentic, minu renti pandud, renti panna, panen renti, active rentals, my rented out items" />
                <meta property="og:title" content="Rentic - Minu Renti Pandud" />
                <meta property="og:description" content="Minu aktiivsed rendid Renticus. Vaata üksikasju enda hetkel välja renditud esemete kohta." />
                <meta property="og:image" content="/logo512.png" />
                <meta property="og:url" content="https://rentic.ee/my_rentals_status" />
            </Helmet>

            <h2 className="text-left pb-5">Minu renti pandud asjad</h2>
            <div className="flex flex-wrap lg:flex-nowrap flex-row w-full gap-y-3 gap-x-6 bg-blue-50 p-3 pl-5 pb-2 mb-8 rounded-xl">
                {/* <div>
                    <Label value={"Nime otsing"} />
                    <Input placeHolder={"Otsi"} value={filterSearch} onChange={(value) => { setFilterSearch(value) }} />
                </div> */}
                <div className="w-full lg:w-[220px]">
                    <Label value={"Staatus"} />
                    <Dropdown options={productStatusOptions} isMultiSelect={false} onSelect={(value) => {
                        const selectedStatus = productStatusOptions.find(option => option.value === value[0])?.value;
                        setFilterStatus(selectedStatus);
                    }} />
                </div>
                <div className="w-full lg:w-[280px] z-10">
                    <Label value={"Rendi periood"} />
                    <DateRangePickerComponent dateRangeChanged={(d) => { setFilterDate(d) }} validChanged={(v) => { }} />
                </div>

            </div>
            <div className="flex flex-col gap-6">


                {dataLoading ? [...Array(6)].map(() => (
                    <ActiveRentalStatusCardSkeleton />
                )) :

                    rentalsList.map((item, index) => {
                        return (
                            <ActiveRentalStatusCard
                                key={index}
                                data={item}
                            />
                        );
                    })}
            </div>
            <div className="flex justify-center mt-4">
                <Pagination count={Math.floor(totalRentalsCount / rentalsTakeCount)} page={rentalsPage + 1}
                            onChange={(e, p) => setRentalsPage(p - 1)}/>
            </div>
        </div>
        )
    )

}